import React, { useContext } from "react";
import { Container, Grid, Card, CardContent, Typography } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../components/pageTitle/PageTitle";
import styles from "./Accounts.module.scss";
import TableToolbar from "../../components/Table/TableToolbar";
import AuthContext from "../../hooks/authContext";
import { packageAccess } from "../../services/helpers";

import {
  DashboardOutlined,
  NotificationsOutlined,
  ReportProblemOutlined,
  HandymanOutlined,
  ErrorOutlineOutlined,
  DescriptionOutlined,
  CalendarTodayOutlined,
  PeopleAltOutlined,
  HelpOutlineOutlined
} from "@mui/icons-material";
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import { CreditCard } from "lucide-react";

const cards = [
  { title: "Appointments", description: "Manage appointments", route: "/account/settings/appointmentPageSetting", icons: <CalendarTodayOutlined /> },
  { title: "My Company", description: "Configure your company settings", route: "/account/settings/companyPageSetting" , icons: <PeopleAltOutlined />},
  { title: "Supplies", description: "Track and order supplies", route: "/account/settings/suppliePageSetting", icons: <HandymanOutlined /> },
  { title: "Notifications", description: "Manage notifications", route: "/account/settings/notificationPageSetting", icons: <NotificationsOutlined /> },
  { title: "Alerts", description: "View alerts and notifications", route: "/", icons: <ReportProblemOutlined /> },
  { title: "Your Payments", description: "Setup & receive payments directly to your bank account", route: "/account/settings/payments", icons: <CreditCard size={24} /> },
  { title: "Issues", description: "Report and resolve issues", route: "/account/settings/issuePageSetting", icons: <ErrorOutlineOutlined /> },
  { title: "Reports", description: "Generate and view reports", route: "/", icons: <DescriptionOutlined /> },
  { title: "Chat", description: "Access chat system", route: "/", icons: <QuestionAnswerOutlinedIcon /> },
  { title: "Help", description: "Access help and support", route: "/" , icons: <HelpOutlineOutlined />},
  { title: "Dashboard Settings", description: "Dashboard Settings", route: "/" , icons: <DashboardOutlined />},
];

const AccountSettings = () => {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  const handleCardClick = (route) => {
    navigate(route);
  };

  const userPackageId = auth?.userProfile?.prdId;
  const allowedPermissions = packageAccess(userPackageId);
  const hasSupplyAccess = allowedPermissions?.routes?.includes("SUPPLIES");
  const hasIssueAccess = allowedPermissions?.routes?.includes("ISSUES");

  const filteredCards = cards?.filter((card) => {
    if (card?.title === "Supplies" && !hasSupplyAccess) return false;
    if (card?.title === "Issues" && !hasIssueAccess) return false;
    return true;
  });

  return (
    <Container>
      <PageTitle
        pageTitle="Settings"
        showBreadcrumb={[
          { label: "Home", to: "/" },
          { label: "Account" },
        ]}
        BreadCrumbCurrentPageTitle={"Settings"}
        showLastSeen={true}
      />
    <div className="sectionBox dark:bg-[#1A1F2C]">
        <TableToolbar
            title={"Settings Page"}
        />
      <Grid container spacing={6} className={styles.grid}>
        {cards?.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              onClick={() => handleCardClick(card.route)}
              className={`${styles.card} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
              style={{borderRadius:"8px"}}
              >
              <CardContent style={{padding:"24px"}}>
                <div className="d-flex flex-center">
                  <div className={`${styles.iconBox} p-8 dark:bg-gray-800 bg-[#F1F5F9] dark:text-white`}  style={{ borderRadius:"8px"}}>
                {card.icons}
                  </div>
                <div className="d-flex flex-direction-column ml-16">
                <Typography variant="body" className={`${styles.title} dark:text-white`}>
                  {card.title}
                </Typography>
                <Typography variant="body" className={styles.description}>
                  {card.description}
                </Typography>
                </div>
                </div>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
    </Container>
  );
};

export default AccountSettings;
